import React from 'react'
import Box from '../components/Box'

export default function Section8() {
    return (
        <div className="section">
            <h2>Section VIII: Student Progress</h2>
            <Box sectionData={'start'} title={'Section VIII: Student Progress'} body={`1. Select the class as described previously. 
            2. Select the student from the list of students on the Students table. 
            3. Two lists will appear with the information described below. 
            4. The  forward  and  back  arrows  will  select  the  previous  and  next  student  in  the  roster.    If  the 
            roster is custom sorted, the custom sort will apply to the order in which the students are cycled.`} />


            <Box title={'Standard Grade Scale Statistics'} body={`• Student Statistics:
o Average: Overall average score for the class.
o Point Total: Raw points possible and earned for the class.
o Highest Grade: The highest single assignment grade.
o Highest Average: The peak average that the student obtained during the class.
o Grades Recorded: Number of grades entered for the student.
o Attended: Number of times marked “Present” and % of attendance entries marked
“Present”.
o Absent: Number of recorded absences. Tap for a list of dates.
o Tardy: Number of recorded tardies. Tap for a list of dates.
o Behavior: Tally for each behavior mark. Tap for a list of categorized records.`} />

            <Box title={'Weighted Grade Scale Statistics'} body={`• Student Statistics (Class):
o Average: Overall average score for the class.
▪ Raw grades include weighted categories with no grades as 0%.
▪ Scaled grades exclude categories without any recorded grades.
o Highest Average: The peak average that the student obtained during the class.
o Grades Recorded: Number of grades entered for the student.
o Attended: Number of times marked “Present” and & of attendance entries marked
“Present”.
o Absent: Number of recorded absences. Tap for a list of dates separated by excused/
unexcused status.
o Tardy: Number of recorded tardies. Tap for a list of dates separated by excused/
unexcused status.
o Behavior: Tally for each behavior mark. Tap for a list of categorized records.
• Student Statistics (Category):
o Category Grade: Average grade for the category.
o Point Total: Raw points possible and earned for the category.
o Category Weight: The weight of the category towards the final grade.`} />

            <Box title={'Recorded Scores'} body={`All  scores  entered  for  this  student.   Categorized  classes  show  scores  divided  by  category.  The 
            following actions are available: 
            • Select an existing score to edit. 
            • Swipe an existing score to delete.  
            • Select an ungraded assignment to enter a score for the assignment.`} />

            <Box sectionData={'end'} title={'Email Student Menu'} body={`The  “Email”  button  is  used  to  share  the  information  in  the  “Student  Status”  view  with  the  student.  
            Tapping the button presents the following options: 
            • Full Report: All of the below reports (except summary) in one email. 
            • Statistics Report: Grade information including averages and point totals. 
            • Grade Report: Transcript of all entered scores. 
            • Attendance  Report:  Record  of  all  recorded  absences  and  tardies  (including  excused  or 
            unexcused status).  Notes remain private and are not included in this email. 
            • Behavior: Report of student behavior marks. 
            • Summary Report: Grades, attendance tallies, and ungraded assignments. 
            • Unscored Assignments: All assignments for which the student has no score recorded. 
            • Blank: Blank email addressed to the student.`} />
        </div>
    )
}